<template>
    <div id="ams-login" class="apply-bootstrap">
        <div class="container">
            <div class="row" id="ams-login-form">
                <div id="amsLogo">
                    <img alt="AMS Login Page" src="../../ams/xsl/images/amsLogo.png">
                </div>
                <div class="login-form-area">
                    <div class="ams-login-centered">
                        <h1>Account Management System</h1>
                    </div>
                    <login-form c-id="loginForm" prop-user-type="ams" :prop-form-params="formParams"></login-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import "@common/syncfusionCss";
import { library } from "@common/library/library";
import { uStore } from "@common/userStore";

const amsLoginCmp = {
    components: {
        loginForm: defineAsyncComponent(() => import('@common/loginForm/loginForm.vue'))
    },
    computed: {
        formParams() {
            return {
                hideInstanceList: true,
                showResetPwd: false,
                inlineLabel: false,
                copyrightContent: this.copyrightContent,
                clientSsoLabelAfterButton: false,
                clientSsoContactInformation: false,
                clientSsoButtonConfig: false
            };
        },
        copyrightContent() {
            return `
                <span>
                    Account Management System (AMS) is a product and service of Samaritan.<br>
                    Copyright &copy; 2000 - ` + (new Date().getFullYear()) + ` Samaritan Software, LLC. All rights reserved world wide.
                </span>
            `;
        },
    },
    methods: {
        processAction: async function (act) {
            switch (act) {
                case 'login':
                    if (library.isFromLocalhost()) {
                        let localSid = library.getCookie('sds_localSid');
                        let loggedUser = await uStore().getLoggedUsers(['ams']);
                        if (localSid) {
                            location.href = PROJECTS_URL + 'ams/index.php?localhostDIS=' + localSid + '&localhostClientID=' + loggedUser;
                            return;
                        }
                        uStore().logout('ams');
                        return;
                    }
                    location.href = '../ams/index.php';
                    location.reload();
                    break;
            }
        },
    }
};

export default amsLoginCmp;
</script>

<style lang="css">

body {
    background-color:#FFFFFF;
    margin:0
}

#ams-login .ams-login-centered {
    text-align: center;
    margin: 20px 0px 10px 0px;
}

#ams-login h1, #ams-login .h1 {
    color: #005C8F;
    font-family: 'Arial';
    font-size: 16pt;
    font-weight: bold;
}

#amsLogo {
    margin: 0 auto;
    display: inline-block;
}

#ams-login button {
    text-transform: none !important;
}

#ams-login {
    text-align: center;
}

#ams-login .e-control-wrapper {
    border-bottom-width: 1px;
    border-bottom-color: #D4D4D4;
}

#ams-login .e-input {
    border-bottom-width: 0px;
    padding: 3px 5px;
}

#ams-login .custom-message-container {
    width: 100%;
}

#ams-login-form {
    width: 490px;
    max-width: 90%;
    margin: 0 auto;
    text-align: center;
    display: block;
}

#ams-login .login-form-area {
    margin: 10px auto;
}

</style>
